module.exports = __webpack_public_path__ + "img/presidentialsweet_room_image01.eacb7099.jpg";